import React from 'react';

import Yup from 'yup';

import ProductOrderForm from 'views/order/ProductOrderForm';

class CoupleProductOrderForm extends ProductOrderForm {
    constructor(props) {
        super(props);

        this.initialValues = this.initialValues.bind(this);
        this.validationScheme = this.validationScheme.bind(this);
        this.createOrderRequest = this.createOrderRequest.bind(this);
    }

    initialValues() {
        let initValues = super.initialValues();
        delete initValues.productSize;
        
        initValues.maleSize = '';
        initValues.femaleSize = '';
        return initValues;
    }

    validationScheme() {
        let validation = super.validationScheme();
        delete validation.productSize;

        validation.maleSize = Yup.string().required("Select a preferrable male size.");
        validation.femaleSize = Yup.string().required("Select a preferrable female size.");

		return validation;
    }


    createOrderRequest(formValue) {
        let order = super.createOrderRequest(formValue);

		order.productSizes = [];
        order.productSizes.push(formValue.maleSize);
        order.productSizes.push(formValue.femaleSize);
		return order;
    }

    displayDeliveryInputs(formValue) {
        const quantity = formValue.quantity;
        const maleSize = formValue.maleSize;
        const femaleSize = formValue.femaleSize;

        return !isNaN(quantity) && maleSize !== '' && femaleSize !== '';
    }

    render() {
        return super.render();
    }
}


export default CoupleProductOrderForm;


// WEBPACK FOOTER //
// ./src/views/order/CoupleProductOrderForm.js